/* ===== Подключение иконок ===== */
import {ReactComponent as tg} from "../assets/icons/social/telegram.svg";
import {ReactComponent as wa} from "../assets/icons/social/whatsapp.svg";
import {ReactComponent as phone} from "../assets/icons/social/phone.svg";
import {ReactComponent as mail} from "../assets/icons/social/email.svg";
import {ReactComponent as vk} from "../assets/icons/social/vk.svg";
import {ReactComponent as youtube} from "../assets/icons/social/youtube.svg";
import {ReactComponent as instagram} from "../assets/icons/social/instagram.svg";
import {ReactComponent as tiktok} from "../assets/icons/social/tiktok.svg";


// 1) Реестр всех иконок (единый источник правды)
const ICONS = {
  // whatsapp: {
  //   id: "whatsapp",
  //   label: "WhatsApp",
  //   href: "https://wa.me/79990000000",
  //   Icon: wa,
  // },
  telegram: {
    id: "telegram",
    label: "Telegram",
    href: "https://t.me/podeludg",
    Icon: tg,
  },
  phone: {
    id: "phone",
    label: "Позвонить",
    href: "tel:+79770906036",
    Icon: phone,
  },
  mail: {
    id: "mail",
    label: "Email",
    href: "mailto:info@site.ru",
    Icon: mail,
  },
  vk: {
    id: "vk",
    label: "VK",
    href: "https://vk.com/yourlink",
    Icon: vk,
  },
  youtube: {
    id: "youtube",
    label: "YouTube",
    href: "https://youtube.com/@yourlink",
    Icon: youtube,
  },
  instagram: {
    id: "instagram",
    label: "Instagram",
    href: "https://instagram.com/yourlink",
    Icon: instagram,
  },
  tiktok: {
    id: "tiktok",
    label: "TikTok",
    href: "https://tiktok.com/@yourlink",
    Icon: tiktok,
  },
  // добавляй сколько угодно
};

// 2) Наборы для разных мест сайта
export const ICON_PRESETS = {
  header: ["whatsapp", "telegram", "phone"], // 3 иконки
  footer: ["whatsapp", "telegram", "phone", "mail", "vk", "youtube", "instagram", "tiktok"], // 8 (хоть 10)
};

// 3) Утилита: получить массив объектов по preset
export function getIconsByPreset(presetName) {
  const ids = ICON_PRESETS[presetName] || [];
  return ids.map((id) => ICONS[id]).filter(Boolean);
}

export default ICONS;
